// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QdCI","top":"styles_top__1kbyl"};